import { render } from "./AccountBindPrompt.vue?vue&type=template&id=2ecb3708&scoped=true"
import script from "./AccountBindPrompt.vue?vue&type=script&lang=js"
export * from "./AccountBindPrompt.vue?vue&type=script&lang=js"

import "./AccountBindPrompt.vue?vue&type=style&index=0&id=2ecb3708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecb3708"]])

export default __exports__